module.exports = __webpack_public_path__ + "f5cdba3c0b92ab5d041e9bd898a2178e.svg";